export default {
  weather: 20012,
  additiveMaterialType: 20048,
  timeSequence: 20501,
};
